import React, { useMemo, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Row,
  Col,
  Button,
  Checkbox,
  Typography,
  Popconfirm,
  Badge
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import { FileTwoTone } from "@ant-design/icons";
import { trainingAPI } from "../../api/TrainingAPI.js";
import { useSelector } from "react-redux";

const { Text } = Typography;

export function GetWellnessReportButton(props) {
  const {
    info: {
      coach_list,
    },
    filter: {
      endDate,

    },
  } = useSelector(({ team }) => team);

  const {
    currentUser: { email: currentUserEmail },
  } = useSelector(({ auth }) => auth);

  const [selectedEmails, setSelectedEmails] = useState({});
  const [surveyResponseCount, setSurveyResponseCount] = useState(undefined);

  useEffect(() => {
    if (!endDate) {
      message.error("Please select valid date to generate the report");
      return;
    }

    trainingAPI
    .surveyreponsecount(endDate)
    .then((data) => setSurveyResponseCount(data))
    .catch((err) => {
      console.log(err);
      setSurveyResponseCount(undefined);
    });
  }, [endDate]);


  const onChangeEmailSelection = (option) => {
    setSelectedEmails({ ...selectedEmails, [option]: !selectedEmails[option] });
  };

  const sendWellnessEmail = () => {
    if (!endDate) {
      message.error("Please select valid date to generate the report");
      return;
    }
    
    let emails = Object.keys(selectedEmails).filter(
      (key) => selectedEmails[key] === true
    );
    if (emails.length == 0) {
      message.info("Please select at least one email recipient for the report");
      return;
    }


    trainingAPI
      .wellnessEmail(endDate, emails)
      .then((data) => {
        message.success("Email Sent!");
      })
      .catch((data) => {
        message.error("Error sending email.");
      });
  };

  const handleWellnessNotification = () => {
    trainingAPI
      .sendWellnessNotification(endDate)
      .then((data) => {
        message.success(data);
      })
      .catch((data) => {
        message.error(data);
      });
  };

  const handleRPENotification = () => {
    trainingAPI
      .sendRPENotification(endDate)
      .then((data) => {
        message.success(data);
      })
      .catch((data) => {
        message.error(data);
      });
  };


	const sendNotificationButtons = (
		<>
		  <hr />
		  <Row gutter={[0, 8]} align="middle">
			<Col span={12} style={{textAlign: 'center'}}>
			  <Button
				className="survey-count-button"
				type="primary"
				onClick={handleWellnessNotification}
			  >
				Send <br />
				<b>Wellness survey</b>
				<br /> notification
				<br />
				{/* <Tag icon={<CheckCircleOutlined />} color="geekblue" bordered={true}>{`${(surveyResponseCount?.wellness?.filter(x=>x.submitted===true) || []).length} / ${surveyResponseCount?.wellness?.length || 0}`}</Tag> */}
				<Badge
				  color="geekblue"
				  count={`${
					(
					  surveyResponseCount?.wellness?.filter(
						(x) => x.submitted === true
					  ) || []
					).length
				  } / ${surveyResponseCount?.wellness?.length || 0}`}
				/>
			  </Button>
			</Col>
	
			<Col span={12} style={{textAlign: 'center'}}>
			  <Button
				className="survey-count-button"
				type="primary"
				onClick={handleRPENotification}
			  >
				Send <br />
				<b>RPE survey</b>
				<br />
				notification
				<br />
				<Badge
				  color="geekblue"
				  count={`${
					(
					  surveyResponseCount?.rpe?.filter(
						(x) => x.submitted === true
					  ) || []
					).length
				  } / ${surveyResponseCount?.rpe?.length || 0}`}
				/>
			  </Button>
			</Col>
		  </Row>
		  <hr />
		</>
	  );

    const popConfirmText = (
      <>
        <Text>
          Would you like to generate a detailed report?
          <br />
        </Text>
        <div style={{ marginTop: "0.5em" }}>
          Please select the emails that should receive the report:
        </div>
  
        <Col style={{ marginTop: "0.5em" }}>
          {coach_list
            .filter((x) => x.email == currentUserEmail)
            .map((item) => (
              <Row>
                <Checkbox
                  checked={selectedEmails[item.email] || false}
                  onChange={() => onChangeEmailSelection(item.email)}
                >
                  {item.first_name} {item.last_name}{" "}
                  <span style={{ fontSize: 13 }}>({item.email})</span>
                </Checkbox>
              </Row>
            ))}
          {coach_list
            .filter((x) => x.email != currentUserEmail)
            .map((item, index) => (
              <Row key={index}>
                <Checkbox
                  checked={selectedEmails[item.email] || false}
                  onChange={() => onChangeEmailSelection(item.email)}
                >
                  {item.first_name} {item.last_name}{" "}
                  <span style={{ fontSize: 13 }}>({item.email})</span>
                </Checkbox>
              </Row>
            ))}
        </Col>
        

        {sendNotificationButtons}
      </>
    );



  return (
    <>
    <Popconfirm
    placement="bottom"
    onConfirm={sendWellnessEmail}
    icon={<FileTwoTone />}
    okText="Yes"
    cancelText="No"
    title={popConfirmText}
  >
    <Button>
      Get Report
    </Button>
  </Popconfirm>		
    </>
  )

};